const FIELDSET = 'FIELDSET';
const TEXTAREA = 'TEXTAREA';
const INPUT = 'INPUT';
const SELECT = 'SELECT';

export const fieldTypes = {
  FIELDSET,
  TEXTAREA,
  INPUT,
  SELECT,
};
